<template>

  <div>

    <div class="columns is-mobile is-gapless">

      <div class="column"><b-icon v-if="icon" class="icon" pack="mdi" :icon="icon"></b-icon>{{label}}</div>
      <div class="column has-text-right"><b-switch @input="updateSetting" type="is-dark" :value="value"></b-switch></div>

    </div>

  </div>

</template>

<script>
    
  import { mapGetters, mapActions } from "vuex";

  export default {

    name: 'SwitchField',

    props: ['name',  'label', 'value', 'icon', 'default', 'applyTo'],

    computed : {
      valueOrDefault(){        
        return (this.value)?this.value:this.default;
      }
    },

    methods:{
     
      updateSetting(val){        
        this.$emit('change', {name:this.name, value:val});
      }

    }
 
  }
    
</script>

<style scoped>

.icon{
  color:#aaa;
  margin-right:1em;
}

</style>
